import { ProductTime } from '../ProductTime/ProductTime'
import { useEffect } from 'react'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { useAppSelector } from '../../hooks/useAppSelector'
import { selectFilterFields } from '../../store/selectors/configChangesHistorySelectors'
import { fetchConfigChangeHistory } from '../../store/async-thunks/configChangeHistory/fetchConfigChangeHistory'
import { ConfigChangeHistoryFilters } from './ConfigChangeHistoryFilters'
import { ConfigChangeHistoryTable } from './ConfigChangeHistoryTable'
import { SyncConfigUpdate } from '../buttons/SyncConfigUpdate'

interface Props {
    guid: string
}

export const ConfigChangeHistoryBar = ({ guid }: Props) => {
    const dispatch = useAppDispatch()
    const filterFields = useAppSelector(selectFilterFields)

    useEffect(() => {
        dispatch(fetchConfigChangeHistory({ productId: guid, ...filterFields }))
    }, [dispatch, guid]) // eslint-disable-line

    return (
        <>
            <div className="app-light-color pt-3 d-flex justify-content-between mb-3">
                <div className="px-4 pt-2 pb-3 nav-dark">
                    CONFIGURATION CHANGE HISTORY
                </div>
                <ProductTime
                    guid={guid}
                    className="pe-4 pt-2 pb-2 nav-dark"
                />
            </div>
            <div className="px-3 pt-2 pb-3 nav-dark">
                <SyncConfigUpdate
                    guid={guid}
                    className="ms-2 mb-4"
                />
                <ConfigChangeHistoryFilters guid={guid} />
                <ConfigChangeHistoryTable guid={guid} />
            </div>
        </>
    )
}
